import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_SERVICE_PLAN_CONTROLLED,
    CLEAR_SERVICE_PLAN_CONTROLLED_ERROR,
    LOAD_SERVICE_PLAN_CONTROLLED_REQUEST,
    LOAD_SERVICE_PLAN_CONTROLLED_SUCCESS,
    LOAD_SERVICE_PLAN_CONTROLLED_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_SERVICE_PLAN_CONTROLLED,
    CLEAR_ERROR: CLEAR_SERVICE_PLAN_CONTROLLED_ERROR,
    LOAD_REQUEST: LOAD_SERVICE_PLAN_CONTROLLED_REQUEST,
    LOAD_SUCCESS: LOAD_SERVICE_PLAN_CONTROLLED_SUCCESS,
    LOAD_FAILURE: LOAD_SERVICE_PLAN_CONTROLLED_FAILURE
}